export default __webpack_public_path__ + "static/gs-6-explainmodel--mobile-3b1d1db38aea638275a96b584ac08471.webp";